import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionReveal from "./SectionReveal";

const TEASER_VIDEO_SRC = `${process.env.PUBLIC_URL}/video/subscription-bg.mp4`;

const SubscriptionTeaser = () => {
  return (
    <section
      id="subscription-teaser"
      data-testid="subscription-teaser-section"
      className="relative overflow-hidden bg-[#0A0A0A] border-y border-white/5 py-24 sm:py-32"
    >
      {/* Background video */}
      <video
        src={TEASER_VIDEO_SRC}
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        data-testid="subscription-teaser-video"
      />
      {/* Dark overlay for legibility */}
      <div className="absolute inset-0 bg-black/75" aria-hidden="true" />
      {/* Gradient fades into adjacent sections */}
      <div
        className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#050505] to-transparent"
        aria-hidden="true"
      />
      <div
        className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#050505] to-transparent"
        aria-hidden="true"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <SectionReveal className="md:col-span-7">
            <span
              className="block text-xs font-bold uppercase tracking-[0.3em] text-zinc-500 mb-6"
              data-testid="subscription-teaser-eyebrow"
            >
              02 — The Subscription Option
            </span>
            <h2
              className="text-4xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tight leading-[0.95] text-white"
              data-testid="subscription-teaser-headline"
            >
              An in-house
              <br />
              content team.
              <br />
              <span className="text-zinc-500">Without the overhead.</span>
            </h2>
            <div className="mt-10" data-testid="subscription-teaser-pitch">
              <div className="text-xl sm:text-2xl font-bold text-white leading-snug">
                A dedicated month of production for far less than booking it
                project by project.
              </div>
              <div className="mt-3 text-[10px] font-bold uppercase tracking-[0.25em] text-zinc-500">
                One flat rate · Every production level · Cancel anytime
              </div>
            </div>
            <Link
              to="/subscription"
              data-testid="subscription-teaser-cta"
              className="mt-10 group inline-flex items-center justify-center gap-3 px-10 py-5 bg-white text-black font-bold text-xs sm:text-sm uppercase tracking-[0.25em] hover:bg-zinc-200 transition-all duration-300"
            >
              See What&apos;s Included
              <ArrowUpRight
                size={18}
                className="transition-transform duration-500 group-hover:rotate-45"
              />
            </Link>
          </SectionReveal>

          <SectionReveal className="md:col-span-5 md:pt-6" delay={0.15}>
            <p className="text-base sm:text-lg font-light text-zinc-400 tracking-wide leading-relaxed">
              Building a content team in-house means recruiting, salaries,
              benefits, and the gear and software to support them — all before
              the first frame is cut. Our subscription replaces it with one
              flat monthly line item —{" "}
              <span className="text-white font-medium">
                no HR management, no per project paperwork and invoice
                headaches, no commitments
              </span>
              .
            </p>
          </SectionReveal>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionTeaser;
